import PropTypes from "prop-types"

import StripeJsContainer from "../stripe_js_container"
import CheckoutForm from "shared/components/stripe/checkout_form"

export default function UpdatePaymentInfo(props) {
  const buttonConfig = {
    buttonType: "",
    cta: "Update payment",
    submittingCopy: "Updating...",
  }

  const processedAfterPaymentMethodSetup = async (paymentMethod, checkoutFormReset) => {
    await fetch(props.updatePaymentUrl, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": window.App.authenticityToken,
      },
      body: JSON.stringify({
        payment_method: paymentMethod,
      }),
    })
      .then(result => {
        return result.json()
      })
      .then(result => {
        if (result.redirect_to) {
          window.appendFlash("Payment info updated!", "success")
          window.location.assign(result.redirect_to)
        } else {
          window.appendFlash("Payment info failed. Please contact us to get help.", "danger")
          checkoutFormReset()
          window.App.loadZendeskMessenger()
        }
      })
      .catch(response => {
        window.appendFlash("Payment info failed. Please contact us to get help.", "danger")
        checkoutFormReset()
        window.App.loadZendeskMessenger()
      })
  }

  return (
    <StripeJsContainer selectedPrice={props.currentPrice} email={props.userEmail}>
      <CheckoutForm
        buttonConfig={buttonConfig}
        email={props.userEmail}
        onCreateSubscriptionCancel={() => {}}
        onCreateSubscriptionStart={() => {}}
        processedAfterPaymentMethodSetup={processedAfterPaymentMethodSetup}
        promoCodeConfig={null}
      />
    </StripeJsContainer>
  )
}

UpdatePaymentInfo.propTypes = {
  currentPrice: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
  updatePaymentUrl: PropTypes.string.isRequired,
}
